export default "__VITE_ASSET__42222137__"